import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';

export const MORE_OPTIONS_ID = 'more-data-available-option';

export const useMoreMessage = (
  label?: TimesheetLabel | null,
  optionKey?: string
): any => {
  const { formatMessage } = useIntl();
  const labelText = formatMessage({ id: `searchableChip.more.${label?.type}` });
  const key = optionKey ?? 'name';

  const message = useMemo(
    () =>
      ({
        id: MORE_OPTIONS_ID,
        [`${key}`]: formatMessage(
          { id: 'searchableChip.more.optionsText' },
          {
            results: labelText
          }
        )
      } as any),
    [formatMessage, labelText, key]
  );
  return { message };
};
